function NoMatch404Page() {
  return <div data-testid="page404">404 Page</div>;
}

export default NoMatch404Page;
